
import { Routes, Route } from 'react-router-dom'
import { constants } from '../module'
import AddEditSubmission from 'features/fbt-submissions/components/add-edit-submission'
import ViewSubmissions from 'features/fbt-submissions/components/view-submissions'

const FbtSubmissionsRoutes = () => (
  <Routes>
    <Route path={constants.PATH_ADD_SUBMISSION.replace(/^\//, '')} element={<AddEditSubmission />} />
    <Route path={constants.PATH_EDIT_SUBMISSION.replace(/^\//, '')} element={<AddEditSubmission />} />
    <Route path={constants.PATH_VIEW_SUBMISSIONS.replace(/^\//, '')} element={<ViewSubmissions />} />
  </Routes>
)

export default FbtSubmissionsRoutes
